import gsap from 'gsap';

const hamburger = document.querySelector('.hamburger');
hamburger?.addEventListener('click', (): void => {
  hamburger.classList.toggle('active');
  const nav = document.querySelector('nav');
  nav?.classList.toggle('active');
});

// Hero intro animation
gsap.from(['.greeting-text', '.name', '.role'], {
  opacity: 0,
  y: 20,
  duration: 0.8,
  stagger: 0.1,
  ease: 'power2.out',
});

gsap.from('.hero-actions', {
  opacity: 0,
  y: 16,
  duration: 0.6,
  delay: 0.4,
  ease: 'power2.out',
});

// Simple reveal on scroll for experience items and case studies (later trigger)
const revealOnScroll = (selector: string): void => {
  const elements = document.querySelectorAll<HTMLElement>(selector);

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          gsap.to(entry.target, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power2.out',
            overwrite: 'auto',
          });
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.3,
      rootMargin: '0px 0px -10% 0px',
    },
  );

  elements.forEach(el => {
    gsap.set(el, { opacity: 0, y: 24 });
    observer.observe(el);
  });
};

revealOnScroll('.experience-item');
revealOnScroll('.case-study');
